module.exports = __webpack_public_path__ + "static/media/ic_account_circle.1ca00c73.png";